const token = "UfRsd63GrrOg8iSyBo";

function fetchProducts(colors, exterior) {
  const colorsMap = colors?.map(({ code }) => code);

  async function fetchData() {
    try {
      const response = await fetch("https://siltek-pss.kovalska.work/api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          method: "colors.get.products",
          params: {
            query: {
              colors: colorsMap,
              group: `${exterior ? "" : "Інтер'єрні фарби"}`,
            },
            size: 500,
          },
        }),
      });
      const data = await response.json();
      return data.result?.documents;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error("Error fetching data");
    }
  }
  return fetchData();
}

export async function colorsGetProducts(result, exterior) {
  try {
    const products = await fetchProducts(result, exterior);
    // console.log(products);
    const mergedResult = JSON.parse(JSON.stringify(result));
    mergedResult.forEach((color) => {
      color.products = products?.filter(
        (product) => product.color === color.code,
      );

      if (color.type === "paint" && exterior) {
        color.products = color.products.filter(
          (product) => product.group === "Фасадні фарби",
        );
      } else if (color.type === "deco") {
        color.products = color.products.filter(
          (product) => product.group === "Декоративні штукатурки",
        );
      }
    });
    return mergedResult;
  } catch (error) {
    console.error("Error merging arrays:", error);
    throw error;
  }
}

export function getMosaicProducts(mosaicResult) {
  const noEmpty = mosaicResult?.filter(({ color }) => color.id !== "");

  const fill = mosaicResult.reduce((acc, item, index) => {
    const key = `fill_${item.id}`;

    if (noEmpty?.length === 1) {
      acc[key] = item.color.id !== "" ? item.color.id : noEmpty[0].color?.id;
    } else if (noEmpty?.length === 2) {
      acc[key] =
        item.color.id !== ""
          ? item.color.id
          : index % 2 === 0
          ? noEmpty[0].color?.id
          : noEmpty[1].color?.id;
    } else {
      acc[key] = item.color.id !== "" ? item.color.id : 6;
    }

    return acc;
  }, {});

  async function fetchData() {
    try {
      const response = await fetch("https://siltek-pss.kovalska.work/api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          method: "mosaic.get.mosaic",
          params: {
            query: fill,
          },
        }),
      });
      const data = await response.json();
      return data.result?.documents;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error("Error fetching data");
    }
  }
  return fetchData();
}
